import type { FC } from 'react';
import React from 'react';

import { Box, Typography, useTheme, Zoom } from '@mui/material';

import { StickyDashedLine } from '@pages/networking/Network/components/StickyLine/StickyLine.style';
import { InfoIcon } from '@setup/svg-icons/svg-icons';
import { MuiTooltip } from '@shared/ui-kit';

import type { SxProps, Theme, TypographyOwnProps } from '@mui/material';

type LinePropsType = {
  text: string;
  variantBorder?: 'dashed' | 'solid';
  count?: number;
  sxLine?: SxProps<Theme>;
  tooltipText?: string;
  typographyVariant?: TypographyOwnProps['variant'];
};
// TODO - change count to MuiBage
export const Line: FC<LinePropsType> = ({
  tooltipText,
  text,
  variantBorder = 'dashed',
  count,
  sxLine,
  typographyVariant,
}) => {
  const theme = useTheme();

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      gap="12px"
      sx={{ ...sxLine, userSelect: 'none' }}
    >
      <Box flexShrink={0} display={'flex'} alignItems={'center'}>
        <Typography color={theme.palette.case.neutral.n800} variant={typographyVariant ?? 't14m'}>
          {text}
        </Typography>
        <Zoom in={!!count} unmountOnExit>
          <Box
            sx={{
              ml: '6px',
              width: '20px',
              height: '20px',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: theme.palette.case.neutral.n200,
            }}
          >
            <Typography color={theme.palette.case.neutral.n900} variant={'t12r'}>
              {count}
            </Typography>
          </Box>
        </Zoom>
        <Zoom in={!!tooltipText} unmountOnExit>
          <Box
            sx={{
              ml: '4px',
            }}
          >
            <MuiTooltip title={tooltipText || ''}>
              <Box
                sx={{
                  cursor: 'pointer',
                  ml: '6px',
                  pb: '2px',
                  svg: {
                    width: '16px',
                    height: '16px',
                    path: {
                      fill: theme.palette.case.neutral.n500,
                    },
                  },
                }}
              >
                <InfoIcon />
              </Box>
            </MuiTooltip>
          </Box>
        </Zoom>
      </Box>

      <StickyDashedLine variantBorder={variantBorder} />
    </Box>
  );
};
